import { Card } from '@mui/material';
import { forwardRef } from 'react';
import FacebookConditionComponent from './facebook-condition.component';
import GBusinessConditionComponent from './googleMyBusiness-condition.component';
import InstagramConditionComponent from './instagram-condition.component';
import LinkedInConditionComponent from './linkedin-condition.component';
import PinterstConditionComponent from './pinterst-condition.component';
import TiktokConditionComponent from './tiktok-condition.component';
import TwitterConditionComponent from './twitter-condition.component';
import ThreadsConditionComponent from './threads-condition.component';
import YoutubeConditionComponent from './youtube-condition.component';
import BlueskyConditionComponent from './bluesky-condition.component';
import SnapchatConditionCompontent from './snapchat-condition.compontent';

const PostConditionComponent = forwardRef(
  (
    {
      updateRequestData,
      handleConditionErrors,
      isOrgConnectedProfilesData,
      googleMyBusinessConditionRef,
      tiktokConditionRef,
      linkedInConditionRef,
      youtubeConditionRef,
      twitterConditionRef,
      threadsConditionRef,
      instagramConditionRef,
      facebookConditionRef,
      pinterestConditionRef,
      blueskyConditionRef,
      snapchatConditionRef,
    },
    ref
  ) => {
    return (
      <Card style={{ boxShadow: 'none', borderRadius: 1 }}>
        <FacebookConditionComponent
          ref={facebookConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <InstagramConditionComponent
          ref={instagramConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <TwitterConditionComponent
          ref={twitterConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <ThreadsConditionComponent
          ref={threadsConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <BlueskyConditionComponent
          ref={blueskyConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <YoutubeConditionComponent
          ref={youtubeConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <LinkedInConditionComponent
          ref={linkedInConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <GBusinessConditionComponent
          ref={googleMyBusinessConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <PinterstConditionComponent
          ref={pinterestConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <TiktokConditionComponent
          ref={tiktokConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
        <SnapchatConditionCompontent
          ref={snapchatConditionRef}
          isOrgConnectedProfilesData={isOrgConnectedProfilesData}
          updateRequestData={updateRequestData}
        />
      </Card>
    );
  }
);

export default PostConditionComponent;
